// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.PatientOtherInformationRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientOtherInformationRequest extends GandalfModelBase {

	@GandalfLabel('Alternate ID')
	@GandalfValidator({ sizeString: { message: 'Alternate ID cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	alternateId!: string | null;

	@GandalfLabel('DOB')
	@GandalfValidator({ notNull: { message: 'DOB is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	dob!: Date;

	@GandalfConstantDecorator(constants.EstablishedStatus)
	@GandalfLabel('Established Status')
	@GandalfValidator({ notNull: { message: 'Established Status is required' } })
	@GandalfProperty({ designType: constants.EstablishedStatus, isRequired: true })
	establishedStatus!: constants.EstablishedStatus;

	@GandalfLabel('Ethnicity Declined')
	@GandalfProperty({ designType: Boolean })
	ethnicityDeclined!: boolean | null;

	@GandalfLabel('Ethnicity')
	@GandalfArray(Number)
	ethnicityIds!: number[] | null;

	@GandalfConstantDecorator(constants.Gender)
	@GandalfLabel('Gender')
	@GandalfValidator({ notNull: { message: 'Gender is required' } })
	@GandalfProperty({ designType: constants.Gender, isRequired: true })
	gender!: constants.Gender;

	@GandalfConstantDecorator(constants.GenderIdentity)
	@GandalfLabel('Gender Identity')
	@GandalfProperty({ designType: constants.GenderIdentity })
	genderIdentity!: constants.GenderIdentity | null;

	@GandalfLabel('Guarantor')
	@GandalfProperty({ designType: Number })
	guarantorId!: number | null;

	@GandalfConstantDecorator(constants.PersonInterpreterAssistance)
	@GandalfLabel('Interpreter Assistance')
	@GandalfProperty({ designType: constants.PersonInterpreterAssistance })
	interpreterAssistance!: constants.PersonInterpreterAssistance | null;

	@GandalfLabel('Last 4 SSN')
	@GandalfValidator({ sizeString: { message: 'Last 4 SSN must be 4 characters in length', minLength: 4, maxLength: 4 } })
	@GandalfProperty({ designType: String })
	last4Ssn!: string | null;

	@GandalfLabel('Preferred Pronoun')
	@GandalfProperty({ designType: Number })
	preferredPronounId!: number | null;

	@GandalfLabel('Race Declined')
	@GandalfProperty({ designType: Boolean })
	raceDeclined!: boolean | null;

	@GandalfLabel('Race')
	@GandalfArray(Number)
	raceIds!: number[] | null;

	@GandalfConstantDecorator(constants.SexualOrientation)
	@GandalfLabel('Sexual Orientation')
	@GandalfProperty({ designType: constants.SexualOrientation })
	sexualOrientation!: constants.SexualOrientation | null;

	@GandalfLabel('SIN/PHN')
	@GandalfValidator({ sizeString: { message: 'SIN/PHN cannot be longer than 128 characters', minLength: 0, maxLength: 128 } })
	@GandalfValidator({ sin: { message: 'SIN/PHN must only contain alphanumeric or dash characters' } })
	@GandalfProperty({ designType: String })
	sin!: string | null;

	@GandalfLabel('Spoken Language Declined')
	@GandalfProperty({ designType: Boolean })
	spokenLanguageDeclined!: boolean | null;

	@GandalfLabel('Spoken Language')
	@GandalfProperty({ designType: Number })
	spokenLanguageId!: number | null;

	@GandalfLabel('SSN')
	@GandalfValidator({ sizeString: { message: 'SSN cannot be longer than 128 characters', minLength: 0, maxLength: 128 } })
	@GandalfValidator({ socialSecurityNumber: { message: 'Social security number must contain 9 digits' } })
	@GandalfProperty({ designType: String })
	ssn!: string | null;

	@GandalfLabel('Tribal Affiliation Declined')
	@GandalfProperty({ designType: Boolean })
	tribalAffiliationDeclined!: boolean | null;

	@GandalfLabel('Tribal Affiliation')
	@GandalfProperty({ designType: Number })
	tribalAffiliationId!: number | null;

	@GandalfLabel('Written Language Declined')
	@GandalfProperty({ designType: Boolean })
	writtenLanguageDeclined!: boolean | null;

	@GandalfLabel('Written Language')
	@GandalfProperty({ designType: Number })
	writtenLanguageId!: number | null;

}
